import { h, Component } from "preact";

class Language extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLang: "PT"
    };
  }

  handleChange = e => {
    console.log("e.target.value");
    console.log(e.target.value);
    this.setState({ currentLang: e.target.value });
    this.props.callback(e.target.value);
  };

  render() {
    return (
      <label style={{ padding: "3px" }}>
        <select class="uk-select" onChange={this.handleChange}>
          <option>PT</option>
          <option>EN</option>
          <option>ES</option>
        </select>
      </label>
    );
  }
}

export default Language;
